import React from 'react'
import cx from 'classnames'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import s from './Note.scss'
import { string } from 'common/helpers'


export const noteTypes = [ 'alert' ] as const

export type NoteType = typeof noteTypes[number]

type NoteProps = {
  type: NoteType
  dataTestId?: string
  message: string | ReactIntlMessage
}

const Note: React.FunctionComponent<NoteProps> = (props) => {
  const { children, type, message, dataTestId } = props
  const rootClassName = cx(s.note, s[type])

  if (children) {
    return (
      <Box className={rootClassName} p={16} dataTestId={dataTestId}>{children}</Box>
    )
  }

  return (
    <Box className={rootClassName} p={16} dataTestId={dataTestId}>
      <Text message={message} size="16-24" />
    </Box>
  )
}


export default Note
